"use client";

import { createIcon } from "@chakra-ui/react";

const ChevronRightLightSvgIcon = createIcon({
  displayName: "ChevronRightLightSvgIcon",
  viewBox: "0 0 20 20",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M10.8863 8.27291L5.27679 2.15348L4.33398 3.182L8.33399 7.54564L8.98535 8.27291L8.33398 9.00018L4.33398 13.3638L5.27679 14.3923L10.8863 8.27291Z" fill="currentColor"/>
  ),
});

export default ChevronRightLightSvgIcon;
